import React from "react";
import { Form, Input, Button, Checkbox, Modal } from "antd";
import { Field, reduxForm } from "redux-form";
import {connect} from 'react-redux';
import {userPostFetch} from '../redux/actions';
import RegistrationForm from "./Register";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

class LoginForm extends React.Component {
  constructor() {
    super();

    this.state = {
      name: "",
      email: "",
      password: "",
      isLoggedIn: false
    };

    this.handleNameChange = (event) => {
      this.setState({ name: event.target.value });
    };

    this.handleEmailChange = (event) => {
      this.setState({ email: event.target.value });
    };

    this.handlePasswordChange = (event) => {
      this.setState(
        { password: event.target.value }
      );
    };
  }
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault()
    this.props.userPostFetch(this.state)
  }

  submit = (values) => {
    console.log(values);
  };
  state = {
    modal1Visible: false,
    modal2Visible: false,
  };

  setModal1Visible(modal1Visible) {
    this.setState({ modal1Visible });
  }

  setModal2Visible(modal2Visible) {
    this.setState({ modal2Visible });
  }

  render() {
    const onFinish = (values) => {
      console.log("Success:", values);
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };
    const { handleSubmit } = this.props;
    return (
      <div>

        <Form
          {...layout}
          name="basic"
          onSubmit={this.handleSubmit}
          initialValues={{
            remember: true,
          }}
          onFinish={this.handleSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Username"
            name="username"
            value={this.state.name}
            onChange={this.handleChange}
            rules={[
              {
                required: true,
                message: "Please input your username!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            value={this.state.password}
            onChange={this.handleChange}
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item {...tailLayout} name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <br />
            <br />
            <a onClick={() => this.setModal2Visible(true)}>
              Don't have an account? register now!
            </a>
          </Form.Item>
          <Modal
            title="Vertically centered modal dialog"
            centered
            style={{ width: 600 }}
            visible={this.state.modal2Visible}
            onCancel={() => this.setModal2Visible(false)}
          >
            <RegistrationForm />
          </Modal>
        </Form>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  userPostFetch: userInfo => dispatch(userPostFetch(userInfo))
})
export default LoginForm;
